import { render, staticRenderFns } from "./BaseFormContainer.vue?vue&type=template&id=7d803914"
import script from "./BaseFormContainer.vue?vue&type=script&lang=ts"
export * from "./BaseFormContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports